import { createSelector } from 'reselect';

export const registerByEmailStateSelector = state => state.auth.registerByEmail;

export const registerByEmailSelector = createSelector(
  registerByEmailStateSelector,
  s => s.email
);

export const registerByEmailPasswordSelector = createSelector(
  registerByEmailStateSelector,
  s => s.password
);

export const registerByEmailConfirmPasswordSelector = createSelector(
  registerByEmailStateSelector,
  s => s.confirmPassword
);

export const registerByEmailFormErrorsSelector = createSelector(
  registerByEmailStateSelector,
  s => s.formErrors
);
